import React from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Creatable from 'react-select/creatable';
import { connect } from 'react-redux';

const LocalizedCategoryField = ({
  additions,
  locale,
  object,
  setter,
  ...props
}) => {
  const intl = useIntl();
  const propertyName = `category${locale.substring(0, 2)?.toUpperCase() || ''}`;
  const options =
    additions?.length > 0
      ? [...new Set([...additions.map((addition) => addition[propertyName])])]
          .filter((category) => !!category)
          .map((value) => ({ label: value, value: value }))
      : [];
  const value = object && {
    label: object[propertyName],
    value: object[propertyName],
  };

  return (
    <AvGroup
      data-testid="localizedCategoryInput"
      className="react-select form-label-group"
    >
      <Creatable
        data-testid="categoryInputTest"
        id={object?.id}
        name={propertyName}
        noOptionsMessage={() =>
          intl.formatMessage({
            id: 'additionCategoryNoOptionsAvailableToSelect',
          })
        }
        formatCreateLabel={(input) =>
          intl.formatMessage({ id: 'reactSelectCreateLabel' }, { name: input })
        }
        className={'react-select-container'}
        classNamePrefix={'react-select'}
        value={value}
        onChange={(data) => {
          setter({
            ...object,
            [propertyName]: data?.value || null,
          });
        }}
        placeholder={intl.formatMessage({ id: propertyName })}
        options={options}
        isClearable
        {...props}
      />
      <Label className="floating-label" for={object?.id}>
        <FormattedMessage id={propertyName} />
      </Label>
    </AvGroup>
  );
};

LocalizedCategoryField.propTypes = {
  locale: PropTypes.string,
  object: PropTypes.object,
};

const mapStateToProps = (state) => ({
  additions: state.store.foodItemAdditions,
});

export default connect(mapStateToProps)(LocalizedCategoryField);
